import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MessageText\DeleteMessageTextController::deleteMethod
* @see app/Http/Controllers/MessageText/DeleteMessageTextController.php
* @route '/api/message-text/{message_text}'
*/
export const deleteMethod = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/message-text/{message_text}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\MessageText\DeleteMessageTextController::deleteMethod
* @see app/Http/Controllers/MessageText/DeleteMessageTextController.php
* @route '/api/message-text/{message_text}'
*/
deleteMethod.url = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { message_text: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { message_text: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            message_text: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        message_text: typeof args.message_text === 'object'
        ? args.message_text.id
        : args.message_text,
    }

    return deleteMethod.definition.url
            .replace('{message_text}', parsedArgs.message_text.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\MessageText\DeleteMessageTextController::deleteMethod
* @see app/Http/Controllers/MessageText/DeleteMessageTextController.php
* @route '/api/message-text/{message_text}'
*/
deleteMethod.delete = (args: { message_text: string | number | { id: string | number } } | [message_text: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\MessageText\DeleteMessageTextController::undo
* @see app/Http/Controllers/MessageText/DeleteMessageTextController.php
* @route '/api/message-text/{message_text}/undo-delete'
*/
export const undo = (args: { message_text: string | number } | [message_text: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/message-text/{message_text}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\MessageText\DeleteMessageTextController::undo
* @see app/Http/Controllers/MessageText/DeleteMessageTextController.php
* @route '/api/message-text/{message_text}/undo-delete'
*/
undo.url = (args: { message_text: string | number } | [message_text: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { message_text: args }
    }

    if (Array.isArray(args)) {
        args = {
            message_text: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        message_text: args.message_text,
    }

    return undo.definition.url
            .replace('{message_text}', parsedArgs.message_text.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\MessageText\DeleteMessageTextController::undo
* @see app/Http/Controllers/MessageText/DeleteMessageTextController.php
* @route '/api/message-text/{message_text}/undo-delete'
*/
undo.get = (args: { message_text: string | number } | [message_text: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\MessageText\DeleteMessageTextController::undo
* @see app/Http/Controllers/MessageText/DeleteMessageTextController.php
* @route '/api/message-text/{message_text}/undo-delete'
*/
undo.head = (args: { message_text: string | number } | [message_text: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteMessageTextController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteMessageTextController